export default "__VITE_ASSET__66b7c163__"